import {
	DOM_CVSURVEY_TAGNAME,
	ICVSurveyComponent,
	JSON_CVSURVEY_KEYNAME,
	JSON_CVSURVEYFORMID_KEYNAME,
	SurveyComponentType,
} from "@ms-ofb/floodgate-shared-typings";

class CVSurveyComponent implements ICVSurveyComponent {
	public static make(data: CVSurveyComponent.CVSurveyComponentData): ICVSurveyComponent {
		try {
			return new CVSurveyComponent(data);
		} catch (e) {
			return null;
		}
	}

	private data: CVSurveyComponent.CVSurveyComponentData;

	public constructor(data: CVSurveyComponent.CVSurveyComponentData) {
		if (!data) {
			throw new Error("data must not be null");
		}
		if (!data.customerVoiceFormId) {
			throw new Error("data.formID must not be null or empty");
		}

		this.data = data;
	}

	public getType(): SurveyComponentType {
		return SurveyComponentType.CVSurvey;
	}

	public getFormId(): string {
		return this.data.customerVoiceFormId;
	}

	// @Override
	public getDomElements(doc: Document): Element[] {
		if (!doc) {
			throw new Error("Document must not be null");
		}
		const element: Element = doc.createElement(DOM_CVSURVEY_TAGNAME);
		return [element];
	}

	// @Override
	public getJsonElements(): object {
		const result: object = {};

		result[JSON_CVSURVEY_KEYNAME] = this.getFormId();
		return result;
	}

	// @Override
	public getComponentJson(): object {
		return {
			[JSON_CVSURVEYFORMID_KEYNAME]: this.getFormId(),
		};
	}
}

module CVSurveyComponent {
	export class CVSurveyComponentData {
		public customerVoiceFormId: string;
	}
}

export default CVSurveyComponent;
